import { Pipe, PipeTransform } from '@angular/core';
import { MarkdownConverter } from '../helpers/markdown-converter';

@Pipe({ name: 'markdownToHtml' })
export class MarkdownToHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    try {
      return MarkdownConverter.toHtml(value);
    } catch (error) {
      console.error('Error parsing markdown:', error);
      return value; // Return original value if parsing fails
    }
  }
}
